import React, { Component } from 'react'

import _ from 'lodash'

import { Segment, Header, Message, Icon } from 'semantic-ui-react'

import './PublishPreview.css'

class CopyrightContentDetectorPublishPreview extends Component {
  render() {
    const { publishUrl } = this.props

    return (
      <Segment padded className="copyright-content-detector-publish-preview">
        <Header as="h3" icon="external alternate">
          CCD公開プレビュー
        </Header>

        {_.isEmpty(publishUrl) ? (
          <Message icon negative size="tiny">
            <Icon name="warning circle" />
            <Message.Content>
              <Message.Header>公開URLが見つかりません</Message.Header>
              <p>情報を確認するか、もう一度お試しください。</p>
            </Message.Content>
          </Message>
        ) : (
          <iframe src={publishUrl} title="CCD公開プレビュー" />
        )}
      </Segment>
    )
  }
}

export default CopyrightContentDetectorPublishPreview
